import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable no-undef */
// eslint-disable-next-line import/no-extraneous-dependencies
import { embedDashboard } from '@superset-ui/embedded-sdk';
import React, { useEffect, useLayoutEffect, useState, useCallback } from 'react';
import { PropTypes } from 'prop-types';
import { Container } from 'reactstrap';
import config from '../../config.json';
import entityComposition from '../common/classes/entityComposition';
import useWindowDimensions from '../../utils/useWindowDimensions';
const Superset = _ref => {
  let _ref$superset = _ref.superset,
    superset = _ref$superset === void 0 ? null : _ref$superset,
    _ref$dashboardTitle = _ref.dashboardTitle,
    dashboardTitle = _ref$dashboardTitle === void 0 ? null : _ref$dashboardTitle;
  const _useWindowDimensions = useWindowDimensions(),
    height = _useWindowDimensions.height;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  const _ref2 = superset || {},
    token = _ref2.token,
    _ref2$dashboards = _ref2.dashboards,
    dashboards = _ref2$dashboards === void 0 ? [] : _ref2$dashboards;
  useEffect(() => {
    if (!dashboards.length) {
      return;
    }
    const filtered = dashboards.filter(dash => dash.name === dashboardTitle);
    if (filtered.length) {
      setSelected(filtered[0].embedID);
    }
  }, [dashboardTitle, dashboards]);
  const resizeIframe = useCallback(() => {
    const iframe = document.querySelector('iframe');
    if (iframe) {
      iframe.style.minHeight = "".concat(height - 92 - 15 - 15, "px");
      iframe.style.width = '100%'; // Set the width of the iframe
    }
  }, [height]);
  /**
   * Use layout to ensure the div is rendered
   * before trying to embed the dashboard.
   */
  useLayoutEffect(() => {
    if (!selected || !token) {
      return;
    }
    embedDashboard({
      id: selected,
      supersetDomain: config.supersetURL,
      mountPoint: document.getElementById('superset-container'),
      fetchGuestToken: () => token,
      dashboardUiConfig: {
        hideTitle: true,
        hideChartControls: false,
        hideTab: true
      }
    });
    resizeIframe();
    // We don't want to regenerate the dashboard every time the window size
    // changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected, dashboardTitle, token]);
  useEffect(() => {
    resizeIframe();
  }, [resizeIframe]);
  if (dashboardTitle === null) {
    return 'No dashboards found, please contact your administrator.';
  }
  return /*#__PURE__*/React.createElement(Container, {
    fluid: true
  }, /*#__PURE__*/React.createElement("div", {
    id: "superset-container",
    "data-testid": "superset-container"
  }));
};
export { Superset as TestSuperset };
Superset.propTypes = {
  superset: PropTypes.shape({
    token: PropTypes.string,
    dashboards: PropTypes.arrayOf(PropTypes.shape({}))
  }),
  dashboardTitle: PropTypes.string
};
export default entityComposition(Superset, [], {
  superset: state => {
    var _state$login;
    return state === null || state === void 0 || (_state$login = state.login) === null || _state$login === void 0 || (_state$login = _state$login.user) === null || _state$login === void 0 ? void 0 : _state$login.superset;
  }
});